import { ACTIVITY_TYPES as aTypes } from '@shared/Resources/types';
export const ACTIVITY_TYPES = aTypes;
export const MONGO_ID_LENGTH = 24;
